import api from './api';

export interface Template {
  id?: string;
  title: string;
  description?: string;
  icon?: string;
  instructions?: string;
  helperPrompt?: string;
  categoryId: string;
  order?: number;
  isAvailable?: boolean; // Indicates if template is available for user's plan
}

export interface TemplateCategory {
  id?: string;
  name: string;
  order?: number;
  templates?: Template[];
}

class TemplateService {
  async getCategories(): Promise<TemplateCategory[]> {
    return await api.get<TemplateCategory[]>('/api/templates/categories');
  }

  async getCategoriesWithTemplates(): Promise<TemplateCategory[]> {
    return await api.get<TemplateCategory[]>('/api/templates/categories-with-templates');
  }

  async getTemplatesByCategory(categoryId: string): Promise<Template[]> {
    return await api.get<Template[]>(`/api/templates/by-category/${categoryId}`);
  }
}

const templateService = new TemplateService();
export default templateService;